import { createContext } from "react"

const PageContext = createContext<{page: any, dispatchPage: any}>({
    page: {},
    dispatchPage: () => {}
})

export default PageContext